import { render, staticRenderFns } from "./UIMenu.vue?vue&type=template&id=4d065342&scoped=true&"
import script from "./UIMenu.vue?vue&type=script&lang=js&"
export * from "./UIMenu.vue?vue&type=script&lang=js&"
import style0 from "./UIMenu.vue?vue&type=style&index=0&id=4d065342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d065342",
  null
  
)

export default component.exports